"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("../icon"));

require("../../css/shared/clear_button.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClearButton = function ClearButton(_ref) {
  var className = _ref.className,
      i18n = _ref.i18n,
      onClick = _ref.onClick;
  var clearButtonClasses = {
    'vn-clear-button': true
  };

  if (className) {
    clearButtonClasses[className] = true;
  }

  var handleKeyDownClear = function handleKeyDownClear(event) {
    switch (event.keyCode) {
      case 32: // SPACE

      case 13:
        // ENTER
        event.preventDefault();
        event.stopPropagation();
        onClick();
        break;

      default:
        break;
    }
  };

  return _react.default.createElement("button", {
    "aria-label": i18n.clear,
    className: (0, _classnames.default)(clearButtonClasses),
    tabIndex: 0,
    title: i18n.clear,
    type: "button",
    onClick: onClick,
    onKeyDown: handleKeyDownClear
  }, _react.default.createElement(_icon.default, {
    color: "foreground",
    name: "close"
  }));
};

ClearButton.propTypes = {
  className: _propTypes.default.string,
  i18n: _propTypes.default.shape({
    clear: _propTypes.default.string.isRequired
  }),
  onClick: _propTypes.default.func.isRequired
};
ClearButton.defaultProps = {
  className: undefined,
  i18n: {
    clear: 'Clear'
  }
};
ClearButton.displayName = 'ClearButton';
var _default = ClearButton;
exports.default = _default;